/* eslint-disable react/no-unescaped-entities */
/* eslint-disable import/no-unresolved */
import React, { useState, useEffect, useRef } from "react";
import { Link as ScrollLink } from "react-scroll";
import { Link, useNavigate } from "react-router-dom";
import { Container, Button, Nav, Row, Col } from "react-bootstrap";
import { Checkbox, ImageElement, RippleEffect } from "components";
import Navbar from "react-bootstrap/Navbar";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Mousewheel, Autoplay, Pagination } from "swiper/modules";
import ModalComponent from "components/UiElement/Modal/Index";
import { Select, Upload } from "antd";
import routesMap from "routeControl/userRouteMap";
import { getSessionStorage, setSessionStorage } from "utils";

function Theme02Static() {
  const [isActive, setIsActive] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const oneSubscriptionData = getSessionStorage("oneSubscriptionData");

  const navigate = useNavigate();
  const path = {
    1: `${routesMap?.LAYOUTFOUR?.path}/${1}`,
    4: `${routesMap?.LAYOUTFOUR?.path}/${4}`,
    3: routesMap?.LAYOUTTHREE?.path,
  };

  const Navigation = () => {
    console.log("oneSubscriptionData", oneSubscriptionData);
    if (oneSubscriptionData && oneSubscriptionData?.memorialId === null) {
      navigate(path?.[oneSubscriptionData?.subscription?.layout]);
      setSessionStorage("oneSubscriptionData", oneSubscriptionData);
    } else {
      navigate(routesMap?.CHOOSE_PLAN?.path);
    }
  };
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      setIsActive(false);
    };
    handleResize();
    // Add event listener for window resize
    window.addEventListener("resize", handleResize);
    // Remove event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []); // Empty dependency array ensures that the effect runs only once on mount
  const toggleClass = () => {
    if (windowWidth <= 991) {
      setIsActive(!isActive);
    }
  };
  const handleClose = () => {
    setIsActive(false);
  };
  // Add and Remove Class on scroll
  const [scrolltopdata, setscrolltopdata] = useState(false);
  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY < 50) {
        setscrolltopdata("");
      } else {
        setscrolltopdata("navbar_scroll");
      }
    });
  }, []);

  useEffect(() => {
    if ([""].includes()) {
      document.querySelector(".theme02Header").style.paddingTop = `0px`;
    } else {
      setTimeout(() => {
        let navbar = document.querySelector(".navbar").clientHeight;
        document.querySelector(
          ".theme02Header"
        ).style.paddingTop = `${navbar}px`;
      }, 100);
    }
  });

  // share modal
  const [shareModal, setShareModal] = useState(false);
  const handleCloseModal = () => {
    setShareModal(false);
  };
  // comment Modal
  const [commentModal, setCommentModal] = useState(false);
  const handleCloseModalComment = () => {
    setCommentModal(false);
  };
  /* image modal */
  const [showModalImage, setModalImage] = useState(false);
  const handleCloseModalImage = () => {
    setModalImage(false);
  };
  /* image modal memory */
  const [showModalImageMemory, setModalImageMemory] = useState(false);
  const handleCloseModalImageMemory = () => {
    setModalImageMemory(false);
  };
  /* report modal */
  const [showReportModal, setReportModal] = useState(false);
  const handleCloseModalReport = () => {
    setReportModal(false);
  };
  /* memeories video modal */
  const [showVideoModal, setVideoModal] = useState(false);
  const handleCloseModalVideo = () => {
    setVideoModal(false);
  };
  /* memeories full video modal */
  const [showVideoFullModal, setVideoFullModal] = useState(false);
  const handleCloseModalVideoFull = () => {
    setVideoFullModal(false);
    setVideoModal(true);
  };
  const handleVideoFullShow = () => {
    setVideoFullModal(true);
    setVideoModal(false);
  };
  /* memeories audio modal */
  const [showAudioModal, setAudioModal] = useState(false);
  const handleCloseModalAudio = () => {
    setAudioModal(false);
  };
  /* memeories pdf modal */
  const [showPdfModal, setPdfModal] = useState(false);
  const handleCloseModalPdf = () => {
    setPdfModal(false);
  };
  //  header click section redirect function
  const [offset, setOffset] = useState(0);
  useEffect(() => {
    let navbarMenu = document.querySelector(".theme02Header").clientHeight;
    setOffset(navbarMenu);
  });

  const videoMemories = [
    {
      id: 1,
      name: "Friendship Chronicles",
      duration: "08:45",
      thumbnail: "modal-video-01.webp",
      alt: "",
    },
    {
      id: 2,
      name: "Love & Relationships",
      duration: "08:45",
      thumbnail: "modal-video-02.webp",
    },
    {
      id: 3,
      name: "Adventures in Youth",
      duration: "08:45",
      thumbnail: "modal-video-03.webp",
    },
    {
      id: 4,
      name: "Innocence Unveiled",
      duration: "08:45",
      thumbnail: "modal-video-04.webp",
    },
    {
      id: 5,
      name: "Teenage Dreams",
      duration: "08:45",
      thumbnail: "modal-video-05.webp",
    },
    {
      id: 6,
      name: "Friendship Chronicles",
      duration: "08:45",
      thumbnail: "modal-video-06.webp",
    },
  ];
  const audioMemories = [
    {
      id: 1,
      name: "Friendship Chronicles",
      audioUrl: "",
      duration: "09:45",
    },
    {
      id: 2,
      name: "Journey of Love",
      audioUrl: "",
      duration: "09:45",
    },
    {
      id: 3,
      name: "Innocence Unveiled",
      audioUrl: "",
      duration: "09:45",
    },
    {
      id: 4,
      name: "Adventures in Youth",
      audioUrl: "",
      duration: "09:45",
    },
    {
      id: 5,
      name: "Friendship Chronicles",
      audioUrl: "",
      duration: "09:45",
    },
    {
      id: 6,
      name: "Journey of Love",
      audioUrl: "",
      duration: "09:45",
    },
  ];
  /* PDF Modal Select */
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [individualCheckboxes, setIndividualCheckboxes] = useState(
    Array(6).fill(false)
  );
  const handleCheckboxChange = (index) => {
    const updatedCheckboxes = [...individualCheckboxes];
    updatedCheckboxes[index] = !updatedCheckboxes[index];
    setIndividualCheckboxes(updatedCheckboxes);
    const allChecked = updatedCheckboxes.every((checkbox) => checkbox);
    setSelectAllChecked(allChecked);
  };
  const handleSelectAll = () => {
    const allChecked = !selectAllChecked;
    setSelectAllChecked(allChecked);
    setIndividualCheckboxes(Array(6).fill(allChecked));
  };
  /* audio Modal Select */
  const [selectAllCheckedAudio, setSelectAllCheckedAudio] = useState(false);
  const [individualCheckboxesAudio, setIndividualCheckboxesAudio] = useState(
    Array(6).fill(false)
  );
  const handleCheckboxChangeAudio = (index) => {
    const updatedCheckboxesAudio = [...individualCheckboxesAudio];
    updatedCheckboxesAudio[index] = !updatedCheckboxesAudio[index];
    setIndividualCheckboxesAudio(updatedCheckboxesAudio);
    const allCheckedAudio = updatedCheckboxesAudio.every(
      (checkbox) => checkbox
    );
    setSelectAllCheckedAudio(allCheckedAudio);
  };
  const handleSelectAllAudio = () => {
    const allCheckedAudio = !selectAllCheckedAudio;
    setSelectAllCheckedAudio(allCheckedAudio);
    setIndividualCheckboxesAudio(Array(6).fill(allCheckedAudio));
  };
  /* video Modal Select */
  const [selectAllCheckedVideo, setSelectAllCheckedVideo] = useState(false);
  const [individualCheckboxesVideo, setIndividualCheckboxesVideo] = useState(
    Array(6).fill(false)
  );
  const handleCheckboxChangeVideo = (index) => {
    const updatedCheckboxesVideo = [...individualCheckboxesVideo];
    updatedCheckboxesVideo[index] = !updatedCheckboxesVideo[index];
    setIndividualCheckboxesVideo(updatedCheckboxesVideo);
    const allCheckedVideo = updatedCheckboxesVideo.every(
      (checkbox) => checkbox
    );
    setSelectAllCheckedVideo(allCheckedVideo);
  };
  const handleSelectAllVideo = () => {
    const allCheckedVideo = !selectAllCheckedVideo;
    setSelectAllCheckedVideo(allCheckedVideo);
    setIndividualCheckboxesVideo(Array(6).fill(allCheckedVideo));
  };

  /** family tree */

  const [isFullscreen, setIsFullscreen] = useState(false);
  const toggleFullscreen = () => {
    if (isFullscreen) document.exitFullscreen();
    else document.documentElement.requestFullscreen();
    setIsFullscreen((prevState) => !prevState);
  };
  // addEventListener("fullscreenchange", (event) => {
  //   console.log(event)
  //   setIsFullscreen(false)
  // });

  function exitHandler() {
    if (
      !document.webkitIsFullScreen &&
      !document.mozFullScreen &&
      !document.msFullscreenElement
    ) {
      setIsFullscreen(false);
    }
  }

  if (document.addEventListener) {
    document.addEventListener("fullscreenchange", exitHandler, false);
    document.addEventListener("mozfullscreenchange", exitHandler, false);
    document.addEventListener("MSFullscreenChange", exitHandler, false);
    document.addEventListener("webkitfullscreenchange", exitHandler, false);
  }

  let tree = document.querySelector(".parent");
  let eleWidth = document.querySelector(".tree");
  let screenWidthOut = eleWidth?.offsetWidth;
  let treeWidthOut = tree?.offsetWidth;
  let isDragging = false;
  let startX;
  let startY;
  let startLeft;
  let startTop;
  let zoomValue;
  if (treeWidthOut > screenWidthOut) {
    zoomValue = screenWidthOut / treeWidthOut;
  } else {
    zoomValue = 1;
  }
  function fitToScreen() {
    let screenWidth = eleWidth?.offsetWidth;
    let treeWidth = tree?.offsetWidth;
    if (treeWidth > screenWidth) {
      let scale = screenWidth / treeWidth;
      zoomValue = scale;
      if (tree) {
        tree.style.transform = `scale(${scale})`;
      }
      tree.style.top = "auto";
      tree.style.left = "auto";
    } else {
      if (tree) {
        tree.style.transform = "scale(1)";
        tree.style.top = "auto";
        tree.style.left = "auto";
      }
    }
  }

  function zoomIn() {
    if (zoomValue < 2) {
      zoomValue += 0.1;
      tree.style.transform = `scale(${zoomValue})`;
    }
  }
  function zoomOut() {
    if (zoomValue > 0.16) {
      zoomValue -= 0.1;
      tree.style.transform = `scale(${zoomValue})`;
    }
  }
  tree?.addEventListener("mousedown", function (event) {
    isDragging = true;
    startX = event.clientX;
    startY = event.clientY;
    startLeft = parseInt(tree?.style.left) || 0;
    startTop = parseInt(tree?.style.top) || 0;
    tree.classList.add("noselect");
    tree.style.cursor = "grabbing";
  });
  tree?.addEventListener("touchstart", function (event) {
    isDragging = true;
    const touchLocation = event.targetTouches[0];
    startX = touchLocation.pageX;
    startY = touchLocation.pageY;
    startLeft = parseInt(tree?.style.left) || 0;
    startTop = parseInt(tree?.style.top) || 0;
    tree.classList.add("noselect");
    tree.style.cursor = "grabbing";
  });

  document.addEventListener("mouseup", function () {
    isDragging = false;
    if (tree) {
      tree.classList.remove("noselect");
      tree.style.cursor = "grab";
    }
  });
  document.addEventListener("touchend", function () {
    isDragging = false;
    if (tree) {
      tree.classList.remove("noselect");
      tree.style.cursor = "grab";
    }
  });

  document.addEventListener("mousemove", function (event) {
    if (isDragging) {
      let offsetX = event.clientX - startX;
      let offsetY = event.clientY - startY;
      if (tree) {
        tree.style.left = `${startLeft + offsetX}px`;
        tree.style.top = `${startTop + offsetY}px`;
      }
    }
  });
  document.addEventListener("touchmove", function (event) {
    if (isDragging) {
      const touchLocation = event.targetTouches[0];
      let offsetX = touchLocation.pageX - startX;
      let offsetY = touchLocation.pageY - startY;
      if (tree) {
        tree.style.left = `${startLeft + offsetX}px`;
        tree.style.top = `${startTop + offsetY}px`;
      }
    }
  });
  tree?.addEventListener("wheel", function (event) {
    event.preventDefault();
    if (event.deltaY < 0) {
      zoomIn();
    } else {
      zoomOut();
    }
  });
  tree?.addEventListener(
    "gestureend",
    function (e) {
      e.preventDefault();
      if (e.scale < 1.0) {
        zoomOut();
      } else if (e.scale > 1.0) {
        zoomIn();
      }
    },
    false
  );
  window.addEventListener("resize", fitToScreen);
  useEffect(() => {
    fitToScreen();
  }, [tree]);

  const treeHeightRef = useRef(null);
  useEffect(() => {
    if (treeHeightRef.current) {
      const treeHeight = treeHeightRef.current.offsetHeight;
      let sheet = document.styleSheets[0];
      sheet.insertRule(`:root{--treeHeightRef:${treeHeight}px}`);
    }
  }, []);
  return (
    <>
      {/* Header 4 Start */}
      <header className="theme02Header bg-light-yellow">
        <Navbar expand="lg" fixed="top" className={`${scrolltopdata}`}>
          <Container>
            <Navbar.Brand
              href={routesMap.USERDASHBOARD.path}
              className="p-0 me-0"
            >
              <ImageElement source="logo.svg" alt="logo" />
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="navbarScroll" />
            <Navbar.Collapse id="navbarScroll">
              <Nav className="m-auto" navbarScroll>
                <ScrollLink
                  activeClass="active"
                  className="nav-link"
                  to="about"
                  spy
                  smooth
                  offset={-offset}
                  duration={800}
                >
                  About
                </ScrollLink>
                <ScrollLink
                  activeClass="active"
                  className="nav-link"
                  to="gallery"
                  spy
                  smooth
                  offset={-offset}
                  duration={800}
                >
                  Gallery
                </ScrollLink>
                <ScrollLink
                  activeClass="active"
                  className="nav-link"
                  to="timeline"
                  spy
                  smooth
                  offset={-offset}
                  duration={800}
                >
                  Timeline
                </ScrollLink>
                <ScrollLink
                  activeClass="active"
                  className="nav-link"
                  to="familytree"
                  spy
                  smooth
                  offset={-offset}
                  duration={800}
                >
                  Family Tree
                </ScrollLink>
              </Nav>
            </Navbar.Collapse>
            <div className="headerBtn">
              <RippleEffect extraClassName="me-md-3 me-2">
                <Button variant="dark" className="btnShare rounded">
                  <em className="icon-saved me-sm-2 me-0" />
                  <span className="d-sm-block d-none lh-1">Save</span>
                </Button>
              </RippleEffect>
              <RippleEffect extraClassName="ms-xxl-1 ms-0">
                <Button
                  variant="danger"
                  className="btnShare rounded"
                  onClick={() => setShareModal(true)}
                >
                  <em className="icon-share me-sm-2 me-0" />
                  <span className="d-sm-block d-none lh-1">Share</span>
                </Button>
                </RippleEffect>
                <RippleEffect>
                <Button
                variant="outline-dark"
                  onClick={(e) => {
                    e.preventDefault();
                    Navigation();
                  }}
                  className="btn btn-outline-dark btn-sm ms-md-3 ms-2 btnShare rounded"
                >
                  <em className="icon-arrow-prev me-sm-2" />
                  <span className="d-none d-sm-block">Back</span>
                </Button>
              </RippleEffect>
              {/* <div className="d-flex publicbtn">
                  <RippleEffect extraClassName="me-md-3 me-2">
                  <Button
                    variant="light"
                    className="btnShare rounded"
                    onClick={() => setShareModal(true)}>
                    <em className="icon-edit me-sm-2 me-0" />
                      <span className="d-sm-block d-none lh-1">
                        Edit
                      </span>
                  </Button>
                  </RippleEffect>
                  <RippleEffect extraClassName="ms-xxl-1 ms-0">
                    <Button
                      variant="danger"
                      className="btnShare rounded w-auto"
                      onClick={() => setShareModal(true)}
                    >
                      Publish
                    </Button>
                  </RippleEffect>
                </div> */}
            </div>
          </Container>
        </Navbar>
      </header>
      {/* Header End */}
      <main className="theme02Page">
        <section className="bannerSec position-relative bg-light-yellow">
          <div className="bannerSec_leftline">
            <svg viewBox="0 0 1920 660">
              <defs>
                <clipPath id="clip-path-homepage-1">
                  <rect
                    id="Frame"
                    width="1920"
                    height="660"
                    transform="translate(4040 -1663)"
                    fill="#fff"
                  />
                </clipPath>
              </defs>
              <g
                id="Path_Group"
                data-name="Path Group"
                transform="translate(-4040 1663)"
                clipPath="url(#clip-path-homepage-1)"
              >
                <path
                  className="mainpath pathanimation"
                  d="M1594.127,274.839c-96.146,24.289-349,28.283-390.076-86.36S1279.909-2.074,1346.9,92.675s-53.237,381.2-375.558,392.348S459.977,312.071,279.407,164.63-125.914-121.3-345.537-128.318-672.293-70.43-672.293-70.43"
                  transform="translate(4512.129 -1508.505)"
                  fill="none"
                  stroke="#EF7635"
                />
              </g>
            </svg>
          </div>
          <div className="bannerSec_inner">
            <div className="bannerSec_Img">
              <div className="bannerSec_inner_content d-flex flex-column justify-content-center">
                <h2 className="mb-0">
                  Barbara D. <br className="d-lg-block d-none" />
                  McCormick
                </h2>
                <span className="mt-xl-3 mt-2">
                  <em className="icon-location" />
                  Los Angeles, US
                </span>
              </div>
            </div>
          </div>
          <div className="bannerSec_rightline">
            <svg viewBox="0 0 1920 660">
              <defs>
                <clipPath id="clip-path2">
                  <rect
                    id="Frame_2"
                    data-name="Frame 2"
                    width="500"
                    height="660"
                    transform="translate(5460 -1663)"
                    fill="#fff"
                  />
                </clipPath>
              </defs>
              <g
                id="Path_Group_Front"
                data-name="Path Group Front"
                transform="translate(-4040 2446)"
              >
                <rect
                  id="Rectangle_940"
                  data-name="Rectangle 940"
                  width="1920"
                  height="660"
                  transform="translate(4040 -2446)"
                  fill="#fff"
                  opacity="0"
                />
                <g id="Small">
                  <g
                    data-name="Path Group"
                    transform="translate(0 -783)"
                    clipPath="url(#clip-path2)"
                  >
                    <path
                      className="mainpath pathanimation"
                      data-name="Path 2"
                      d="M1594.127,274.839c-96.146,24.289-349,28.283-390.076-86.36S1279.909-2.074,1346.9,92.675s-53.237,381.2-375.558,392.348S459.977,312.071,279.407,164.63-125.914-121.3-345.537-128.318-672.293-70.43-672.293-70.43"
                      transform="translate(4512.129 -1508.505)"
                      fill="none"
                      stroke="#EF7635"
                      strokeWidth="25"
                    />
                  </g>
                </g>
              </g>
            </svg>
          </div>
        </section>
        <section className="aboutSec bg-light-yellow" id="about">
          <Container>
            <div className="aboutSec_inner position-relative">
              <div className="d-flex justify-content-between">
                <h3 className="mb-0">About</h3>
                <div className="aboutSec_socialmedia">
                  <ul className="list-unstyled mb-0 d-flex">
                    <li>
                      <Link
                        to="#"
                        className="d-flex justify-content-center align-items-center"
                        aria-label="instagram"
                      >
                        <em className="icon-instagram" />
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="d-flex justify-content-center align-items-center"
                        aria-label="twitter"
                      >
                        <em className="icon-twitter" />
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="d-flex justify-content-center align-items-center"
                        aria-label="facebook"
                      >
                        <em className="icon-facebook" />
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="d-flex justify-content-center align-items-center"
                        onClick={() => setReportModal(true)}
                        aria-label="report"
                      >
                        <em className="icon-report" />
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="aboutSec_list">
                <Row>
                  <Col md={6} sm={12}>
                    <div className="aboutSec_listleft">
                      <ul className="list-unstyled mb-0">
                        <li className="d-flex">
                          <span>Born</span>: September 21, 1985 Los Angeles, US
                        </li>
                        <li className="d-flex">
                          <span>Died</span>: October 10, 2022 Los Angeles, US
                        </li>
                        <li className="d-flex">
                          <span>Spouse</span>: Terry A. Perkins (m. 2014)
                        </li>
                      </ul>
                    </div>
                  </Col>
                  <Col md={6} sm={12}>
                    <div className="aboutSec_listright">
                      <ul className="list-unstyled mb-0">
                        <li className="d-flex">
                          <span>Parents</span>: Robert C.McCormick, Kasandra J.
                          McCormick
                        </li>
                        <li className="d-flex">
                          <span>Children</span>: Kevin J. Perkins, Andrew J.
                          Perkins
                        </li>
                        <li className="d-flex">
                          <span>Siblings</span>: Mallory A. McCormick
                        </li>
                      </ul>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Container>
        </section>
        <section className="biographySec bg-light-yellow py-80">
          <Container>
            <Row>
              <Col md={4} sm={12}>
                <div className="commonHead mb-0">
                  <span className="commonHead_sub">Biography</span>
                  <h2 className="commonHead_title mb-0">
                    Echoes of a <br className="d-xxl-block d-none" /> Lifetime,
                    the <br className="d-xxl-block d-none" /> Unseen
                  </h2>
                </div>
              </Col>
              <Col md={8} sm={12}>
                <p>
                  Barbara D. McCormick, a trailblazing figure in the field of
                  environmental science, has devoted her life to the pursuit of
                  sustainable practices and ecological conservation. Born and
                  raised in the picturesque landscapes of the Pacific Northwest,
                  Barbara developed an early fascination with the delicate
                  balance of nature.
                </p>
                <p>
                  Beyond her academic achievements, Barbara's impact extends to
                  her active involvement in environmental advocacy. She has been
                  a vocal proponent of sustainable policies and has lent her
                  expertise to various conservation initiatives.
                </p>
              </Col>
            </Row>
          </Container>
          <div className="downloadSec">
            <Container>
              <div className="downloadSec_inner">
                <Row className="justify-content-md-between">
                  <Col xxl={2} md={3} sm={4} xs={6}>
                    <div className="storyCard">
                      <div className="storyCard_img position-relative">
                        <ImageElement
                          source="save-stories.webp"
                          alt="save-stories"
                        />
                        <div
                          className="storyCard_btn position-absolute d-flex justify-content-center align-items-center"
                          onClick={() => setVideoModal(true)}
                        >
                          <em className="icon-video" />
                        </div>
                      </div>
                      <h2 className="storyCard_txt text-center mb-0">Video</h2>
                    </div>
                  </Col>
                  <Col xxl={2} md={3} sm={4} xs={6}>
                    <div className="storyCard">
                      <div className="storyCard_img position-relative">
                        <div
                          className="storyCard_btn position-absolute d-flex justify-content-center align-items-center"
                          onClick={() => setAudioModal(true)}
                        >
                          <em className="icon-audio" />
                        </div>
                      </div>
                      <h2 className="storyCard_txt text-center mb-0">Audio</h2>
                    </div>
                  </Col>
                  <Col xxl={2} md={3} sm={4} xs={6}>
                    <div className="storyCard">
                      <div className="storyCard_img position-relative">
                        <div
                          className="storyCard_btn position-absolute d-flex justify-content-center align-items-center"
                          onClick={() => setPdfModal(true)}
                        >
                          <span>
                            <ImageElement source="pdf.svg" alt="save-stories" />
                          </span>
                        </div>
                      </div>
                      <h2 className="storyCard_txt text-center mb-0">PDF</h2>
                    </div>
                  </Col>
                  <Col xxl={4} md={3} sm={6} xs={6}>
                    <div className="d-flex h-100 flex-column justify-content-center storyCnt">
                      <h2>Downloadable Memories</h2>
                      <p className="mb-1 ps-0">
                        Sharing a life legacy for generations to come.
                      </p>
                    </div>
                  </Col>
                </Row>
              </div>
            </Container>
          </div>
        </section>
        <section className={`py-80 memorialSec ${isActive ? "active" : ""}`}>
          <Container fluid className="p-0">
            <Row>
              <Col xs={12}>
                <div className="commonHead commonHead-light  mb-xxl-5 mb-md-4 mb-3 text-center">
                  <div className="commonHead_sub">
                    Click an image to view a timeless memory
                  </div>
                  <h2 className="commonHead_title">
                    Timeless Memories and Significant Places
                  </h2>
                </div>
              </Col>
              <Col xs={12} className="position-relative">
                <div className="placeCard flex-wrap">
                  <Link className="closeBtn" onClick={handleClose}>
                    <em className="icon-close" />
                  </Link>
                  <div className="placeCard_imgBox flex-shrink-0 position-relative">
                    <ImageElement
                      source="theme02/memories-pic.webp"
                      alt="memories-pic"
                      ClassName="w-100 h-100 object-fit-cover"
                    />
                  </div>
                  <div className="placeCard_cntBox flex-shrink-0">
                    <div className="placeCard_cntBox_top">
                      <span className="d-block date">20 Feb 2023</span>
                      <h3>Friendship Saga, Journeying Bonds</h3>
                      <div className="location">
                        <em className="icon-location" />
                        San Francisco, CL
                      </div>
                      <p>
                        Lorem Ipsum is simply dummy text of the printing and
                        typesetting industry. Lorem Ipsum
                      </p>
                    </div>
                    <div className=" d-flex justify-content-between align-items-end count">
                      <div className="me-1 count_txt">
                        <span>1</span>/ 12
                      </div>
                      <div className="flex-shrink-0">
                        <RippleEffect>
                          <Button
                            type="button"
                            className="btn btn-light count_btn me-2 me-lg-3 rounded"
                          >
                            <em className="icon-arrow-right count_btn_arrowLeft" />
                          </Button>
                        </RippleEffect>
                        <RippleEffect>
                          <Button
                            type="button"
                            className="btn btn-danger count_btn rounded"
                          >
                            <em className="icon-arrow-right" />
                          </Button>
                        </RippleEffect>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="mapBox position-relative ms-auto"
                  onClick={toggleClass}
                >
                  <ImageElement source="theme02/map.webp" alt="map" />
                  <div className="mapOverlay" />
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <section className="capturemomentSec py-80" id="gallery">
          <div className="commonHead text-center">
            <div className="commonHead_sub">
              Photographs- Videos- Other Media
            </div>
            <h2 className="commonHead_title mb-0">Captured Memories</h2>
          </div>
          <div className="capturemomentSec_slider">
            <Swiper
              spaceBetween={20}
              slidesPerView={5}
              centeredSlides
              loop
              autoplay={{
                delay: 2000,
                pauseOnMouseEnter: true,
                disableOnInteraction: false,
              }}
              breakpoints={{
                300: {
                  slidesPerView: 1.5,
                },
                480: {
                  slidesPerView: 2,
                },
                576: {
                  slidesPerView: 3,
                },
                768: {
                  spaceBetween: 20,
                  slidesPerView: 4,
                },
                992: {
                  spaceBetween: 30,
                  slidesPerView: 4,
                },
                1200: {
                  spaceBetween: 40,
                  slidesPerView: 5,
                },
                1400: {
                  spaceBetween: 50,
                },
                1600: {
                  spaceBetween: 70,
                },
              }}
              modules={[Autoplay]}
            >
              <SwiperSlide>
                <Link
                  to="#"
                  className="momentCard"
                  onClick={() => setModalImageMemory(true)}
                >
                  <div className="momentCard_img">
                    <div className="momentCard_imginner">
                      <ImageElement
                        source="theme02/capturedmoment-01.webp"
                        alt="capturedmoment"
                      />
                    </div>
                  </div>
                  <h3 className="momentCard_cnt mb-0">
                    A Tale of <br className="d-xl-block d-none" /> Growing Up
                  </h3>
                </Link>
              </SwiperSlide>
              <SwiperSlide>
                <Link
                  to="#"
                  className="momentCard"
                  onClick={() => setModalImageMemory(true)}
                >
                  <div className="momentCard_img">
                    <div className="momentCard_imginner">
                      <ImageElement
                        source="theme02/capturedmoment-02.webp"
                        alt="capturedmoment"
                      />
                    </div>
                  </div>
                  <h3 className="momentCard_cnt mb-0">
                    From Crayons to <br className="d-xl-block d-none" />
                    Graduation
                  </h3>
                </Link>
              </SwiperSlide>
              <SwiperSlide>
                <Link
                  to="#"
                  className="momentCard"
                  onClick={() => setModalImageMemory(true)}
                >
                  <div className="momentCard_img">
                    <div className="momentCard_imginner">
                      <ImageElement
                        source="theme02/capturedmoment-03.webp"
                        alt="capturedmoment"
                      />
                    </div>
                  </div>
                  <h3 className="momentCard_cnt mb-0">
                    Navigating the <br className="d-xl-block d-none" /> Campus
                    of Life
                  </h3>
                </Link>
              </SwiperSlide>
              <SwiperSlide>
                <Link
                  to="#"
                  className="momentCard"
                  onClick={() => setModalImageMemory(true)}
                >
                  <div className="momentCard_img">
                    <div className="momentCard_imginner">
                      <ImageElement
                        source="theme02/capturedmoment-04.webp"
                        alt="capturedmoment"
                      />
                    </div>
                  </div>
                  <h3 className="momentCard_cnt mb-0">
                    Our Matrimonial <br className="d-xl-block d-none" /> Journey
                  </h3>
                </Link>
              </SwiperSlide>
              <SwiperSlide>
                <Link
                  to="#"
                  className="momentCard"
                  onClick={() => setModalImageMemory(true)}
                >
                  <div className="momentCard_img">
                    <div className="momentCard_imginner">
                      <ImageElement
                        source="theme02/capturedmoment-05.webp"
                        alt="capturedmoment"
                      />
                    </div>
                  </div>
                  <h3 className="momentCard_cnt mb-0">
                    A Lifetime in <br className="d-xl-block d-none" /> Frames
                  </h3>
                </Link>
              </SwiperSlide>
              <SwiperSlide>
                <Link
                  to="#"
                  className="momentCard"
                  onClick={() => setModalImageMemory(true)}
                >
                  <div className="momentCard_img">
                    <div className="momentCard_imginner">
                      <ImageElement
                        source="theme02/capturedmoment-02.webp"
                        alt="capturedmoment"
                      />
                    </div>
                  </div>
                  <h3 className="momentCard_cnt mb-0">
                    From Crayons to <br className="d-xl-block d-none" />
                    Graduation
                  </h3>
                </Link>
              </SwiperSlide>
              <SwiperSlide>
                <Link
                  to="#"
                  className="momentCard"
                  onClick={() => setModalImageMemory(true)}
                >
                  <div className="momentCard_img">
                    <div className="momentCard_imginner">
                      <ImageElement
                        source="theme02/capturedmoment-03.webp"
                        alt="capturedmoment"
                      />
                    </div>
                  </div>
                  <h3 className="momentCard_cnt mb-0">
                    Navigating the <br className="d-xl-block d-none" /> Campus
                    of Life
                  </h3>
                </Link>
              </SwiperSlide>
              <SwiperSlide>
                <Link
                  to="#"
                  className="momentCard"
                  onClick={() => setModalImageMemory(true)}
                >
                  <div className="momentCard_img">
                    <div className="momentCard_imginner">
                      <ImageElement
                        source="theme02/capturedmoment-04.webp"
                        alt="capturedmoment"
                      />
                    </div>
                  </div>
                  <h3 className="momentCard_cnt mb-0">
                    Our Matrimonial <br className="d-xl-block d-none" /> Journey
                  </h3>
                </Link>
              </SwiperSlide>
              <SwiperSlide>
                <Link
                  to="#"
                  className="momentCard"
                  onClick={() => setModalImageMemory(true)}
                >
                  <div className="momentCard_img">
                    <div className="momentCard_imginner">
                      <ImageElement
                        source="theme02/capturedmoment-05.webp"
                        alt="capturedmoment"
                      />
                    </div>
                  </div>
                  <h3 className="momentCard_cnt mb-0">
                    A Lifetime in <br className="d-xl-block d-none" /> Frames
                  </h3>
                </Link>
              </SwiperSlide>
              <SwiperSlide>
                <Link
                  to="#"
                  className="momentCard"
                  onClick={() => setModalImageMemory(true)}
                >
                  <div className="momentCard_img">
                    <div className="momentCard_imginner">
                      <ImageElement
                        source="theme02/capturedmoment-01.webp"
                        alt="capturedmoment"
                      />
                    </div>
                  </div>
                  <h3 className="momentCard_cnt mb-0">
                    A Tale of <br className="d-xl-block d-none" /> Growing Up
                  </h3>
                </Link>
              </SwiperSlide>
              <SwiperSlide>
                <Link
                  to="#"
                  className="momentCard"
                  onClick={() => setModalImageMemory(true)}
                >
                  <div className="momentCard_img">
                    <div className="momentCard_imginner">
                      <ImageElement
                        source="theme02/capturedmoment-02.webp"
                        alt="capturedmoment"
                      />
                    </div>
                  </div>
                  <h3 className="momentCard_cnt mb-0">
                    From Crayons to <br className="d-xl-block d-none" />
                    Graduation
                  </h3>
                </Link>
              </SwiperSlide>
              <SwiperSlide>
                <Link
                  to="#"
                  className="momentCard"
                  onClick={() => setModalImageMemory(true)}
                >
                  <div className="momentCard_img">
                    <div className="momentCard_imginner">
                      <ImageElement
                        source="theme02/capturedmoment-03.webp"
                        alt="capturedmoment"
                      />
                    </div>
                  </div>
                  <h3 className="momentCard_cnt mb-0">
                    Navigating the <br className="d-xl-block d-none" /> Campus
                    of Life
                  </h3>
                </Link>
              </SwiperSlide>
              <SwiperSlide>
                <Link
                  to="#"
                  className="momentCard"
                  onClick={() => setModalImageMemory(true)}
                >
                  <div className="momentCard_img">
                    <div className="momentCard_imginner">
                      <ImageElement
                        source="theme02/capturedmoment-04.webp"
                        alt="capturedmoment"
                      />
                    </div>
                  </div>
                  <h3 className="momentCard_cnt mb-0">
                    Our Matrimonial <br className="d-xl-block d-none" /> Journey
                  </h3>
                </Link>
              </SwiperSlide>
              <SwiperSlide>
                <Link
                  to="#"
                  className="momentCard"
                  onClick={() => setModalImageMemory(true)}
                >
                  <div className="momentCard_img">
                    <div className="momentCard_imginner">
                      <ImageElement
                        source="theme02/capturedmoment-05.webp"
                        alt="capturedmoment"
                      />
                    </div>
                  </div>
                  <h3 className="momentCard_cnt mb-0">
                    A Lifetime in <br className="d-xl-block d-none" /> Frames
                  </h3>
                </Link>
              </SwiperSlide>
              <SwiperSlide>
                <Link
                  to="#"
                  className="momentCard"
                  onClick={() => setModalImageMemory(true)}
                >
                  <div className="momentCard_img">
                    <div className="momentCard_imginner">
                      <ImageElement
                        source="theme02/capturedmoment-02.webp"
                        alt="capturedmoment"
                      />
                    </div>
                  </div>
                  <h3 className="momentCard_cnt mb-0">
                    From Crayons to <br className="d-xl-block d-none" />
                    Graduation
                  </h3>
                </Link>
              </SwiperSlide>
              <SwiperSlide>
                <Link
                  to="#"
                  className="momentCard"
                  onClick={() => setModalImageMemory(true)}
                >
                  <div className="momentCard_img">
                    <div className="momentCard_imginner">
                      <ImageElement
                        source="theme02/capturedmoment-03.webp"
                        alt="capturedmoment"
                      />
                    </div>
                  </div>
                  <h3 className="momentCard_cnt mb-0">
                    Navigating the <br className="d-xl-block d-none" />
                    Campus of Life
                  </h3>
                </Link>
              </SwiperSlide>
              <SwiperSlide>
                <Link
                  to="#"
                  className="momentCard"
                  onClick={() => setModalImageMemory(true)}
                >
                  <div className="momentCard_img">
                    <div className="momentCard_imginner">
                      <ImageElement
                        source="theme02/capturedmoment-04.webp"
                        alt="capturedmoment"
                      />
                    </div>
                  </div>
                  <h3 className="momentCard_cnt mb-0">
                    Our Matrimonial <br className="d-xl-block d-none" />
                    Journey
                  </h3>
                </Link>
              </SwiperSlide>
              <SwiperSlide>
                <Link
                  to="#"
                  className="momentCard"
                  onClick={() => setModalImageMemory(true)}
                >
                  <div className="momentCard_img">
                    <div className="momentCard_imginner">
                      <ImageElement
                        source="theme02/capturedmoment-05.webp"
                        alt="capturedmoment"
                      />
                    </div>
                  </div>
                  <h3 className="momentCard_cnt mb-0">
                    A Lifetime in <br className="d-xl-block d-none" />
                    Frames
                  </h3>
                </Link>
              </SwiperSlide>
            </Swiper>
          </div>
        </section>

        {/** theme02 family tree */}
        {/* <section
          className={` familyTree py-80 bg-light-yellow ${isFullscreen ? "fullWidth" : ""
            }`}
          id="familytree"
        >
          <div className="commonHead text-center">
            <div className="commonHead_sub">The Legacy Lives On</div>
            <h2 className="commonHead_title">Our Family Tree</h2>
          </div>
          <div className="familyTreeContainer mx-auto">
            <div className="tree">
              <ul className="tree_inner">
                <li className="parent">
                  <div className="d-flex align-items-end parentsWrap  justify-content-center">
                    <div className="spouseParents">
                      <div className="d-flex align-items-end grandParents flex-row-reverse justify-content-center">
                        <div className="grandParents_item">
                          <a href="#!" className="spouse">
                            <div className="familyCard">
                              <div className="familyCard_img">
                                <ImageElement
                                  className="img-fluid"
                                  source="family-tree/user13.jpg"
                                />
                                <span className="d-flex align-items-center justify-content-center">
                                  <em className="icon-info" />
                                </span>
                              </div>
                              <div className="familyCard_cnt">
                                <h2>G G Mother</h2>
                                <p>May 1961 - Dec 2022</p>
                                <p>Father</p>
                              </div>
                            </div>
                          </a>
                          <a href="#!">
                            <div className="heart d-flex align-items-center justify-content-center">
                              <em className="icon-heart" />
                            </div>
                            <div className="familyCard">
                              <div className="familyCard_img">
                                <ImageElement
                                  className="img-fluid"
                                  source="family-tree/user14.jpg"
                                />
                                <span className="d-flex align-items-center justify-content-center">
                                  <em className="icon-info" />
                                </span>
                              </div>
                              <div className="familyCard_cnt">
                                <h2>G G Father</h2>
                                <p>May 1961 - June 2000</p>
                                <p>Mother</p>
                              </div>
                            </div>
                          </a>
                        </div>
                        <div className="grandParents_item ">
                          <a href="#!" className="spouse">
                            <div className="familyCard">
                              <div className="familyCard_img">
                                <ImageElement
                                  className="img-fluid"
                                  source="family-tree/user13.jpg"
                                />
                                <span className="d-flex align-items-center justify-content-center">
                                  <em className="icon-info" />
                                </span>
                              </div>
                              <div className="familyCard_cnt">
                                <h2>M G Mother</h2>
                                <p>May 1961 - Dec 2022</p>
                                <p>Father</p>
                              </div>
                            </div>
                          </a>
                          <a href="#!">
                            <div className="heart d-flex align-items-center justify-content-center">
                              <em className="icon-heart" />
                            </div>
                            <div className="familyCard">
                              <div className="familyCard_img">
                                <ImageElement
                                  className="img-fluid"
                                  source="family-tree/user14.jpg"
                                />
                                <span className="d-flex align-items-center justify-content-center">
                                  <em className="icon-info" />
                                </span>
                              </div>
                              <div className="familyCard_cnt">
                                <h2>M G Father</h2>
                                <p>May 1961 - June 2000</p>
                                <p>Mother</p>
                              </div>
                            </div>
                          </a>
                        </div>
                      </div>
                      <ul>
                        <li className="child">
                          <a href="#!" className="spouse">
                            <div className="familyCard">
                              <div className="familyCard_img">
                                <ImageElement
                                  className="img-fluid"
                                  source="family-tree/user27.jpg"
                                />
                                <span className="d-flex align-items-center justify-content-center">
                                  <em className="icon-info" />
                                </span>
                              </div>
                              <div className="familyCard_cnt">
                                <h2>G Mother</h2>
                                <p>May 1961 - Dec 2022</p>
                                <p>-</p>
                              </div>
                            </div>
                          </a>
                          <a href="#!">
                            <div className="heart d-flex align-items-center justify-content-center">
                              <em className="icon-heart" />
                            </div>
                            <div className="familyCard">
                              <div className="familyCard_img">
                                <ImageElement
                                  className="img-fluid"
                                  source="family-tree/user12.jpg"
                                />
                                <span className="d-flex align-items-center justify-content-center">
                                  <em className="icon-info" />
                                </span>
                              </div>
                              <div className="familyCard_cnt">
                                <h2>G Father</h2>
                                <p>May 1961 - June 2000</p>
                                <p>-</p>
                              </div>
                            </div>
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div className="mainParents">
                      <div className="d-flex align-items-end grandParents flex-row-reverse justify-content-center">
                        <div className="grandParents_item">
                          <a href="#!" className="spouse">
                            <div className="familyCard">
                              <div className="familyCard_img">
                                <ImageElement
                                  className="img-fluid"
                                  source="family-tree/user13.jpg"
                                />
                                <span className="d-flex align-items-center justify-content-center">
                                  <em className="icon-info" />
                                </span>
                              </div>
                              <div className="familyCard_cnt">
                                <h2>G G Mother</h2>
                                <p>May 1961 - Dec 2022</p>
                                <p>Father</p>
                              </div>
                            </div>
                          </a>
                          <a href="#!">
                            <div className="heart d-flex align-items-center justify-content-center">
                              <em className="icon-heart" />
                            </div>
                            <div className="familyCard">
                              <div className="familyCard_img">
                                <ImageElement
                                  className="img-fluid"
                                  source="family-tree/user14.jpg"
                                />
                                <span className="d-flex align-items-center justify-content-center">
                                  <em className="icon-info" />
                                </span>
                              </div>
                              <div className="familyCard_cnt">
                                <h2>G G Father</h2>
                                <p>May 1961 - June 2000</p>
                                <p>Mother</p>
                              </div>
                            </div>
                          </a>
                        </div>
                        <div className="grandParents_item ">
                          <a href="#!" className="spouse">
                            <div className="familyCard">
                              <div className="familyCard_img">
                                <ImageElement
                                  className="img-fluid"
                                  source="family-tree/user13.jpg"
                                />
                                <span className="d-flex align-items-center justify-content-center">
                                  <em className="icon-info" />
                                </span>
                              </div>
                              <div className="familyCard_cnt">
                                <h2>M G Mother</h2>
                                <p>May 1961 - Dec 2022</p>
                                <p>Father</p>
                              </div>
                            </div>
                          </a>
                          <a href="#!">
                            <div className="heart d-flex align-items-center justify-content-center">
                              <em className="icon-heart" />
                            </div>
                            <div className="familyCard">
                              <div className="familyCard_img">
                                <ImageElement
                                  className="img-fluid"
                                  source="family-tree/user14.jpg"
                                />
                                <span className="d-flex align-items-center justify-content-center">
                                  <em className="icon-info" />
                                </span>
                              </div>
                              <div className="familyCard_cnt">
                                <h2>M G Father</h2>
                                <p>May 1961 - June 2000</p>
                                <p>Mother</p>
                              </div>
                            </div>
                          </a>
                        </div>
                      </div>
                      <ul>
                        <li className="child">
                          <a href="#!" className="spouse">
                            <div className="familyCard">
                              <div className="familyCard_img">
                                <ImageElement
                                  className="img-fluid"
                                  source="family-tree/user15.jpg"
                                />
                                <span className="d-flex align-items-center justify-content-center">
                                  <em className="icon-info" />
                                </span>
                              </div>
                              <div className="familyCard_cnt">
                                <h2>G Mother</h2>
                                <p>May 1961 - Dec 2022</p>
                                <p>-</p>
                              </div>
                            </div>
                          </a>
                          <a href="#!">
                            <div className="heart d-flex align-items-center justify-content-center">
                              <em className="icon-heart" />
                            </div>
                            <div className="familyCard">
                              <div className="familyCard_img">
                                <ImageElement
                                  className="img-fluid"
                                  source="family-tree/user16.jpg"
                                />
                                <span className="d-flex align-items-center justify-content-center">
                                  <em className="icon-info" />
                                </span>
                              </div>
                              <div className="familyCard_cnt">
                                <h2>G Father</h2>
                                <p>May 1961 - June 2000</p>
                                <p>-</p>
                              </div>
                            </div>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <ul>
                    <li className="child">
                      <Link>
                        <div className="familyCard">
                          <div className="familyCard_img">
                            <span className="d-flex align-items-center justify-content-center position-absolute">
                              <em className="icon-info" />
                            </span>
                            <ImageElement
                              className="img-fluid"
                              source="family-tree/user17.jpg"
                            />
                          </div>
                          <div className="familyCard_cnt">
                            <h2>Terry D. Williams</h2>
                            <p>May 1951 -Dec 2022</p>
                            <p>Grand Grand Father</p>
                          </div>
                        </div>
                      </Link>
                      <Link>
                        <div className="heart d-flex align-items-center justify-content-center position-absolute">
                          <em className="icon-heart" />
                        </div>
                        <div className="familyCard">
                          <div className="familyCard_img">
                            <span className="d-flex align-items-center justify-content-center position-absolute">
                              <em className="icon-info" />
                            </span>
                            <ImageElement
                              className="img-fluid"
                              source="family-tree/user18.jpg"
                            />
                          </div>
                          <div className="familyCard_cnt">
                            <h2>Jessica</h2>
                            <p>May 1961 - Dec 2022</p>
                            <p>Grand Grand Mother</p>
                          </div>
                        </div>
                      </Link>
                      <ul>
                        <li className="child">
                          <Link>
                            <div className="familyCard">
                              <div className="familyCard_img">
                                <span className="d-flex align-items-center justify-content-center position-absolute">
                                  <em className="icon-info" />
                                </span>
                                <ImageElement
                                  className="img-fluid"
                                  source="family-tree/user14.jpg"
                                />
                              </div>
                              <div className="familyCard_cnt">
                                <h2>Ron </h2>
                                <p>Sep 12, 1964</p>
                                <p>Great Uncle</p>
                              </div>
                            </div>
                          </Link>
                        </li>
                        <li className="child">
                          <Link className="spouse">
                            <div className="familyCard">
                              <div className="familyCard_img">
                                <span className="d-flex align-items-center justify-content-center position-absolute">
                                  <em className="icon-info" />
                                </span>
                                <ImageElement
                                  className="img-fluid"
                                  source="family-tree/user16.jpg"
                                />
                              </div>
                              <div className="familyCard_cnt">
                                <h2>David</h2>
                                <p>May 1961 - Dec 2022</p>
                                <p>Father</p>
                              </div>
                            </div>
                          </Link>
                          <Link>
                            <div className="heart d-flex align-items-center justify-content-center position-absolute">
                              <em className="icon-heart" />
                            </div>
                            <div className="familyCard">
                              <div className="familyCard_img">
                                <span className="d-flex align-items-center justify-content-center position-absolute">
                                  <em className="icon-info" />
                                </span>
                                <ImageElement
                                  className="img-fluid"
                                  source="family-tree/user15.jpg"
                                />
                              </div>
                              <div className="familyCard_cnt">
                                <h2>Sheila</h2>
                                <p>May 25, 1965</p>
                                <p>Mother</p>
                              </div>
                            </div>
                          </Link>
                          <ul>
                            <li className="child">
                              <Link className="spouse">
                                <div className="familyCard">
                                  <div className="familyCard_img">
                                    <span className="d-flex align-items-center justify-content-center position-absolute">
                                      <em className="icon-info" />
                                    </span>
                                    <ImageElement
                                      className="img-fluid"
                                      source="family-tree/user12.jpg"
                                    />
                                  </div>
                                  <div className="familyCard_cnt">
                                    <h2>Donald</h2>
                                    <p>April 30, 1983</p>
                                    <p>Husband</p>
                                  </div>
                                </div>
                              </Link>
                              <Link>
                                <div className="heart d-flex align-items-center justify-content-center position-absolute">
                                  <em className="icon-heart" />
                                </div>
                                <div className="familyCard">
                                  <div className="familyCard_img">
                                    <span className="d-flex align-items-center justify-content-center position-absolute">
                                      <em className="icon-info" />
                                    </span>
                                    <ImageElement
                                      className="img-fluid"
                                      source="family-tree/user19.jpg"
                                    />
                                  </div>
                                  <div className="familyCard_cnt">
                                    <h2>Cynthia</h2>
                                    <p>March 10, 1986</p>
                                    <p>Me</p>
                                  </div>
                                </div>
                              </Link>
                              <ul>
                                <li>
                                  <Link>
                                    <div className="familyCard">
                                      <div className="familyCard_img">
                                        <span className="d-flex align-items-center justify-content-center position-absolute">
                                          <em className="icon-info" />
                                        </span>
                                        <ImageElement
                                          className="img-fluid"
                                          source="family-tree/user22.jpg"
                                        />
                                      </div>
                                      <div className="familyCard_cnt">
                                        <h2>Mark</h2>
                                        <p>July 28, 2024</p>
                                        <p>Daughter</p>
                                      </div>
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link className="pe-none">
                                    <div className="familyCard">
                                      <div className="familyCard_img">
                                        <ImageElement
                                          className="img-fluid"
                                          source="family-tree/user23.jpg"
                                        />
                                      </div>
                                      <div className="familyCard_cnt">
                                        <h2>Lula</h2>
                                        <p>April 10, 2024</p>
                                        <p>Son</p>
                                      </div>
                                    </div>
                                  </Link>
                                </li>
                              </ul>
                            </li>
                            <li className="child">
                              <Link className="spouse">
                                <div className="familyCard">
                                  <div className="familyCard_img">
                                    <span className="d-flex align-items-center justify-content-center position-absolute">
                                      <em className="icon-info" />
                                    </span>
                                    <ImageElement
                                      className="img-fluid"
                                      source="family-tree/user20.jpg"
                                    />
                                  </div>
                                  <div className="familyCard_cnt">
                                    <h2>Steven</h2>
                                    <p>May 06, 1983</p>
                                    <p>Brother</p>
                                  </div>
                                </div>
                              </Link>
                              <Link className="pe-none ">
                                <div className="heart d-flex align-items-center justify-content-center position-absolute">
                                  <em className="icon-heart" />
                                </div>
                                <div className="familyCard">
                                  <div className="familyCard_img">
                                    <ImageElement
                                      className="img-fluid"
                                      source="family-tree/user21.jpg"
                                    />
                                  </div>
                                  <div className="familyCard_cnt">
                                    <h2>Sandra</h2>
                                    <p>July 28, 1983</p>
                                    <p>Brother Wife</p>
                                  </div>
                                </div>
                              </Link>
                              <ul>
                                <li>
                                  <Link className="pe-none">
                                    <div className="familyCard">
                                      <div className="familyCard_img">
                                        <ImageElement
                                          className="img-fluid"
                                          source="family-tree/user24.jpg"
                                        />
                                      </div>
                                      <div className="familyCard_cnt">
                                        <h2>Perdo</h2>
                                        <p>June 12, 2024</p>
                                        <p>Nephew</p>
                                      </div>
                                    </div>
                                  </Link>
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </li>
                        <li className="child">
                          <Link className="spouse">
                            <div className="familyCard">
                              <div className="familyCard_img">
                                <span className="d-flex align-items-center justify-content-center position-absolute">
                                  <em className="icon-info" />
                                </span>
                                <ImageElement
                                  className="img-fluid"
                                  source="family-tree/user25.jpg"
                                />
                              </div>
                              <div className="familyCard_cnt">
                                <h2>Robert</h2>
                                <p>May 12, 1968</p>
                                <p>Uncle</p>
                              </div>
                            </div>
                          </Link>
                          <Link>
                            <div className="heart d-flex align-items-center justify-content-center position-absolute">
                              <em className="icon-heart" />
                            </div>
                            <div className="familyCard">
                              <div className="familyCard_img">
                                <span className="d-flex align-items-center justify-content-center position-absolute">
                                  <em className="icon-info" />
                                </span>
                                <ImageElement
                                  className="img-fluid"
                                  source="family-tree/user13.jpg"
                                />
                              </div>
                              <div className="familyCard_cnt">
                                <h2>Eva</h2>
                                <p>July 28, 1970</p>
                                <p>Aunt </p>
                              </div>
                            </div>
                          </Link>
                          <ul>
                            <li className="child">
                              <Link className="spouse">
                                <div className="familyCard">
                                  <div className="familyCard_img">
                                    <span className="d-flex align-items-center justify-content-center position-absolute">
                                      <em className="icon-info" />
                                    </span>
                                    <ImageElement
                                      className="img-fluid"
                                      source="family-tree/user26.jpg"
                                    />
                                  </div>
                                  <div className="familyCard_cnt">
                                    <h2>Francisco</h2>
                                    <p>March 12, 1984</p>
                                    <p>Cousin</p>
                                  </div>
                                </div>
                              </Link>
                              <Link>
                                <div className="heart d-flex align-items-center justify-content-center position-absolute">
                                  <em className="icon-heart" />
                                </div>
                                <div className="familyCard">
                                  <div className="familyCard_img">
                                    <span className="d-flex align-items-center justify-content-center position-absolute">
                                      <em className="icon-info" />
                                    </span>
                                    <ImageElement
                                      className="img-fluid"
                                      source="family-tree/user27.jpg"
                                    />
                                  </div>
                                  <div className="familyCard_cnt">
                                    <h2>Amanda</h2>
                                    <p>May 28, 1985</p>
                                    <p>Cousin Wife </p>
                                  </div>
                                </div>
                              </Link>
                              <ul>
                                <li>
                                  <Link>
                                    <div className="familyCard">
                                      <div className="familyCard_img">
                                        <span className="d-flex align-items-center justify-content-center position-absolute">
                                          <em className="icon-info" />
                                        </span>
                                        <ImageElement
                                          className="img-fluid"
                                          source="family-tree/user28.jpg"
                                        />
                                      </div>
                                      <div className="familyCard_cnt">
                                        <h2>Zula</h2>
                                        <p>May 10, 2024</p>
                                        <p>Cousin Daughter</p>
                                      </div>
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link className="pe-none">
                                    <div className="familyCard">
                                      <div className="familyCard_img">
                                        <ImageElement
                                          className="img-fluid"
                                          source="family-tree/user29.jpg"
                                        />
                                      </div>
                                      <div className="familyCard_cnt">
                                        <h2>Cleveland</h2>
                                        <p>February 08, 2024</p>
                                        <p>Cousin Son</p>
                                      </div>
                                    </div>
                                  </Link>
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
              <div className="controls">
                <button onClick={fitToScreen}>
                  <em className="icon-screenfit" />
                </button>
                <button onClick={zoomIn}>
                  <em className="icon-plus" />
                </button>
                <button onClick={zoomOut}>
                  <em className="icon-minus" />
                </button>
                <button onClick={toggleFullscreen}>
                  <em className="icon-treeexpand" />
                </button>
              </div>
            </div>
          </div>
        </section> */}

        {/* theme01 family tree section (use temporarily until theme02 css can be updated) */}
        <section
          className={` familyTree py-80 ${isFullscreen ? "fullWidth" : ""}`}
          id="familytree"
        >
          <div className="familyTreeContainer mx-auto">
            <div className="commonHead text-center">
              <div className="commonHead_sub text-white">
                The Legacy Lives On
              </div>
              <h2 className="commonHead_title text-white">Our Family Tree</h2>
            </div>
            <div className="familyTreeContainer mx-auto">

              <div className="tree">
                <ul className="tree_inner">
                  <li className="parent" >
                    <div className="d-flex align-items-end parentsWrap  justify-content-center">
                      <div className="spouseParents">
                        <div className="d-flex align-items-end grandParents flex-row-reverse justify-content-center">
                          <div className="grandParents_item">
                            <a href="#!" className="spouse">
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement className="img-fluid" source="family-tree/user13.jpg" />
                                  <span className="d-flex align-items-center justify-content-center">
                                    <em className="icon-info" />
                                  </span>
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>G G Mother</h2>
                                  <p>May 1961 - Dec 2022</p>
                                  <p>Father</p>
                                </div>
                              </div>
                            </a>
                            <a href="#!" className="multipleParents">
                              <div className="heart d-flex align-items-center justify-content-center">
                                <em className="icon-heart" />
                              </div>
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement className="img-fluid" source="family-tree/user14.jpg" />
                                  <span className="d-flex align-items-center justify-content-center">
                                    <em className="icon-info" />
                                  </span>
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>G G Father</h2>
                                  <p>May 1961 - June 2000</p>
                                  <p>Mother</p>
                                </div>
                              </div>
                            </a>
                          </div>
                          <div className="grandParents_item ">
                            <a href="#!" className="spouse multipleParents">
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement className="img-fluid" source="family-tree/user13.jpg" />
                                  <span className="d-flex align-items-center justify-content-center">
                                    <em className="icon-info" />
                                  </span>
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>M G Mother</h2>
                                  <p>May 1961 - Dec 2022</p>
                                  <p>Father</p>
                                </div>
                              </div>
                            </a>
                            <a href="#!" className="multipleParents">
                              <div className="heart d-flex align-items-center justify-content-center">
                                <em className="icon-heart" />
                              </div>
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement className="img-fluid" source="family-tree/user14.jpg" />
                                  <span className="d-flex align-items-center justify-content-center">
                                    <em className="icon-info" />
                                  </span>
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>M G Father</h2>
                                  <p>May 1961 - June 2000</p>
                                  <p>Mother</p>
                                </div>
                              </div>
                            </a>
                          </div>
                        </div>
                        <ul className="multipleParents">
                          <li className="child">
                            <a href="#!" className="spouse">
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement className="img-fluid" source="family-tree/user27.jpg" />
                                  <span className="d-flex align-items-center justify-content-center">
                                    <em className="icon-info" />
                                  </span>
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>G Mother</h2>
                                  <p>May 1961 - Dec 2022</p>
                                  <p>-</p>
                                </div>
                              </div>
                            </a>
                            <a href="#!">
                              <div className="heart d-flex align-items-center justify-content-center">
                                <em className="icon-heart" />
                              </div>
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement className="img-fluid" source="family-tree/user12.jpg" />
                                  <span className="d-flex align-items-center justify-content-center">
                                    <em className="icon-info" />
                                  </span>
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>G Father</h2>
                                  <p>May 1961 - June 2000</p>
                                  <p>-</p>
                                </div>
                              </div>
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="mainParents">
                        <div className="d-flex align-items-end grandParents flex-row-reverse justify-content-center">
                          <div className="grandParents_item">
                            <a href="#!" className="spouse">
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement className="img-fluid" source="family-tree/user13.jpg" />
                                  <span className="d-flex align-items-center justify-content-center">
                                    <em className="icon-info" />
                                  </span>
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>G G Mother</h2>
                                  <p>May 1961 - Dec 2022</p>
                                  <p>Father</p>
                                </div>
                              </div>
                            </a>
                            <a href="#!" className="multipleParents">
                              <div className="heart d-flex align-items-center justify-content-center">
                                <em className="icon-heart" />
                              </div>
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement className="img-fluid" source="family-tree/user14.jpg" />
                                  <span className="d-flex align-items-center justify-content-center">
                                    <em className="icon-info" />
                                  </span>
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>G G Father</h2>
                                  <p>May 1961 - June 2000</p>
                                  <p>Mother</p>
                                </div>
                              </div>
                            </a>
                          </div>
                          <div className="grandParents_item ">
                            <a href="#!" className="spouse multipleParents">
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement className="img-fluid" source="family-tree/user13.jpg" />
                                  <span className="d-flex align-items-center justify-content-center">
                                    <em className="icon-info" />
                                  </span>
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>M G Mother</h2>
                                  <p>May 1961 - Dec 2022</p>
                                  <p>Father</p>
                                </div>
                              </div>
                            </a>
                            <a href="#!" className="multipleParents">
                              <div className="heart d-flex align-items-center justify-content-center">
                                <em className="icon-heart" />
                              </div>
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement className="img-fluid" source="family-tree/user14.jpg" />
                                  <span className="d-flex align-items-center justify-content-center">
                                    <em className="icon-info" />
                                  </span>
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>M G Father</h2>
                                  <p>May 1961 - June 2000</p>
                                  <p>Mother</p>
                                </div>
                              </div>
                            </a>
                          </div>
                        </div>
                        <ul className="multipleParents">
                          <li className="child">
                            <a href="#!" className="spouse">
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement className="img-fluid" source="family-tree/user15.jpg" />
                                  <span className="d-flex align-items-center justify-content-center">
                                    <em className="icon-info" />
                                  </span>
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>G Mother</h2>
                                  <p>May 1961 - Dec 2022</p>
                                  <p>-</p>
                                </div>
                              </div>
                            </a>
                            <a href="#!">
                              <div className="heart d-flex align-items-center justify-content-center">
                                <em className="icon-heart" />
                              </div>
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement className="img-fluid" source="family-tree/user16.jpg" />
                                  <span className="d-flex align-items-center justify-content-center">
                                    <em className="icon-info" />
                                  </span>
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>G Father</h2>
                                  <p>May 1961 - June 2000</p>
                                  <p>-</p>
                                </div>
                              </div>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <ul>
                      <li className="child">
                        <Link className="spouse">
                          <div className="familyCard">
                            <div className="familyCard_img">
                              {/* <div className="familyCard_tag" >Parents</div> */}
                              <ImageElement
                                className="img-fluid"
                                source="family-tree/user06.jpg"
                              />
                              <span className="d-flex align-items-center justify-content-center position-absolute">
                                <em className="icon-info" />
                              </span>
                            </div>
                            <div className="familyCard_cnt">
                              <h2>Mother</h2>
                              <p>June 15, 1985 </p>
                              <p>Elder Brother</p>
                            </div>
                          </div>
                        </Link>
                        <Link>
                          <div className="heart d-flex align-items-center justify-content-center position-absolute">
                            <em className="icon-heart" />
                          </div>
                          <div className="familyCard">
                            <div className="familyCard_img">
                              <ImageElement
                                className="img-fluid"
                                source="family-tree/user03.jpg"
                              />
                              <span className="d-flex align-items-center justify-content-center position-absolute">
                                <em className="icon-info" />
                              </span>
                            </div>
                            <div className="familyCard_cnt">
                              <h2>Father</h2>
                              <p>May 11, 1988 </p>
                              <p>Brother's Wife</p>
                            </div>
                          </div>
                        </Link>
                        <ul className="multipleParents bottom">
                          <li className="child">
                            <Link className="pe-none">
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement
                                    className="img-fluid"
                                    source="family-tree/user09.jpg"
                                  />
                                  {/* <span className="d-flex align-items-center justify-content-center position-absolute">
                                        <em className="icon-info" />
                                      </span> */}
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>Me </h2>
                                  <p>January 11, 2020 </p>
                                  <p>Brother's Son</p>
                                </div>
                              </div>
                            </Link>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                </ul>
                <div className="controls">
                  <button onClick={fitToScreen}>
                    <em className="icon-screenfit" />
                  </button>
                  <button onClick={zoomIn}>
                    <em className="icon-plus" />
                  </button>
                  <button onClick={zoomOut}>
                    <em className="icon-minus" />
                  </button>
                  <button onClick={toggleFullscreen}>
                    <em className="icon-treeexpand" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-80 testimonialSec">
          <Container>
            <div className="commonHead">
              <Row className="align-items-end">
                <Col
                  md={9}
                  sm={8}
                  className="mb-sm-0 mb-3 text-sm-start text-center"
                >
                  <div className="commonHead_sub">Heartfelt Reflections</div>
                  <h2 className="commonHead_title mb-0">
                    Memories of Tommy M. Lawrence
                  </h2>
                </Col>
                <Col
                  md={3}
                  sm={4}
                  className="text-sm-end text-start text-center"
                >
                  <RippleEffect extraClassName="justify-content-end">
                    <Button
                      variant="danger"
                      className="rounded mt-0"
                      onClick={() => setCommentModal(true)}
                    >
                      Share A Story
                    </Button>
                  </RippleEffect>
                </Col>
              </Row>
            </div>
            <Row className="justify-content-sm-between justify-content-center align-items-end">
              <Col xs={12} className="mt-xxl-5 mt-0">
                <div className="slider">
                  <Swiper
                    breakpoints={{
                      320: {
                        slidesPerView: 1,
                        spaceBetween: 10,
                      },
                      768: {
                        slidesPerView: 2,
                        spaceBetween: 15,
                      },
                      1400: {
                        slidesPerView: 2,
                        spaceBetween: 40,
                      },
                    }}
                    spaceBetween={40}
                    slidesPerView={2}
                    navigation={{
                      nextEl: ".next",
                      prevEl: ".prev",
                    }}
                    modules={[Navigation]}
                    autoplay={{ delay: 200 }}
                  >
                    <SwiperSlide>
                      <div className="slider_item d-flex align-items-stretch">
                        <div className="d-flex align-items-center justify-content-center flex-column slider_imgbox">
                          <ImageElement
                            source="theme02/slider-01.webp"
                            alt="slider-img"
                          />
                        </div>
                        <div className="slider_cntbox d-flex flex-column justify-content-between">
                          <p>
                            Lorem Ipsum is simply dummy text of the printing and
                            typesetting industry. Lorem Ipsum has been the
                            industry's standard dummy text ever since the 1500s.
                          </p>
                          <div className="d-flex align-items-center">
                            <ImageElement
                              className="smallPic"
                              source="theme02/mike.webp"
                              alt="mike"
                            />
                            <div className="ms-xxl-3 ms-2">
                              <h4>Mike Douglas</h4>
                              <span className="d-flex align-items-center">
                                <em className="icon-location me-2" /> San
                                Francisco, CL
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="slider_item d-flex align-items-stretch">
                        <div className="d-flex align-items-center justify-content-center flex-column slider_imgbox slider_imgbox-pdf">
                          <ImageElement
                            className="smallPic"
                            source="theme02/pdf-white.webp"
                            alt="pdf"
                          />
                          <Link className="viewBtn">View PDF</Link>
                        </div>
                        <div className="slider_cntbox d-flex flex-column justify-content-between">
                          <p>
                            Lorem Ipsum is simply dummy text of the printing and
                            typesetting industry. Lorem Ipsum has been the
                            industry's standard dummy text ever since the 1500s.
                          </p>
                          <div className="d-flex align-items-center">
                            <ImageElement
                              source="theme02/bob-pietrangelo.webp"
                              alt="pietrangelo"
                              className="smallPic"
                            />
                            <div className="ms-xxl-3 ms-2">
                              <h4>Bob Pietrangelo</h4>
                              <span className="d-flex align-items-center">
                                <em className="icon-location me-2" /> San
                                Francisco, CL
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="slider_item d-flex align-items-align-items-stretch">
                        <div className="d-flex align-items-center justify-content-center flex-column slider_imgbox">
                          <ImageElement
                            source="theme02/slider-01.webp"
                            alt="slider-img"
                          />
                        </div>
                        <div className="slider_cntbox d-flex flex-column justify-content-between">
                          <p>
                            Lorem Ipsum is simply dummy text of the printing and
                            typesetting industry. Lorem Ipsum has been the
                            industry's standard dummy text ever since the 1500s.
                          </p>
                          <div className="d-flex align-items-center">
                            <ImageElement
                              className="smallPic"
                              source="theme02/mike.webp"
                              alt="mike"
                            />
                            <div className="ms-xxl-3 ms-2">
                              <h4>Mike Douglas</h4>
                              <span className="d-flex align-items-center">
                                <em className="icon-location me-2" /> San
                                Francisco, CL
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="slider_item d-flex align-items-stretch">
                        <div className="d-flex align-items-center justify-content-center flex-column slider_imgbox slider_imgbox-pdf">
                          <ImageElement
                            className="smallPic"
                            source="theme02/pdf-white.webp"
                            alt="pdf"
                          />
                          <Link className="viewBtn">View PDF</Link>
                        </div>
                        <div className="slider_cntbox d-flex flex-column justify-content-between">
                          <p>
                            Lorem Ipsum is simply dummy text of the printing and
                            typesetting industry. Lorem Ipsum has been the
                            industry's standard dummy text ever since the 1500s.
                          </p>
                          <div className="d-flex align-items-center">
                            <ImageElement
                              source="theme02/bob-pietrangelo.webp"
                              alt="pietrangelo"
                              className="smallPic"
                            />
                            <div className="ms-xxl-3 ms-2">
                              <h4>Bob Pietrangelo</h4>
                              <span className="d-flex align-items-center">
                                <em className="icon-location me-2" /> San
                                Francisco, CL
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  </Swiper>
                  <div className="slider_arrowbtn">
                    <Button variant="danger" type="button" className=" prev">
                      <em className="icon-arrow-right" />
                    </Button>
                    <Button variant="danger" type="button" className=" next">
                      <em className="icon-arrow-right" />
                    </Button>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <section className="py-80 bg-light-yellow storySec" id="timeline">
          <Container>
            <Row>
              <Col xs={12}>
                <div className="commonHead text-sm-start text-center">
                  <div className="commonHead_sub">Chronicles of a Life</div>
                  <h2 className="commonHead_title mb-md-2 mb-1">
                    A Timeline of Meaningful Memories
                  </h2>
                  <p className="mb-0">
                    Where each chapter unfolds a unique tale of growth,
                    resilience, and self-discovery.
                  </p>
                </div>
              </Col>
              <div className="scrollEffect">
                <Swiper
                  autoHeight
                  loop
                  slidesPerView={4}
                  mousewheel
                  modules={[Mousewheel, Autoplay]}
                  autoplay={{
                    delay: 100,
                    pauseOnMouseEnter: true,
                    disableOnInteraction: false,
                  }}
                  breakpoints={{
                    320: {
                      direction: "horizontal",
                      slidesPerView: 1,
                      autoplay: {
                        delay: 25000,
                        pauseOnMouseEnter: true,
                        disableOnInteraction: false,
                      },
                    },
                    576: {
                      direction: "vertical",
                      slidesPerView: 4,
                      autoplay: false,
                    },
                  }}
                >
                  <SwiperSlide className="scrollEffect_main w-100">
                    <div className="scrollEffect_textBox d-flex align-items-center justify-content-between">
                      <div>
                        <span>20 September 1985</span>
                        <h3>Childhood and Education</h3>
                        <p>
                          This period is characterized by growth, education, and
                          personal development...
                        </p>
                      </div>
                      <RippleEffect>
                        <Link
                          className="btn btn-danger"
                          onClick={() => setModalImage(true)}
                        >
                          See Details
                        </Link>
                      </RippleEffect>
                    </div>
                    <div className="scrollEffect_imgBox">
                      <ImageElement
                        id="img1"
                        source="theme02/evolution-01.webp"
                        alt=" evolution-01 "
                      />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide className="scrollEffect_main w-100">
                    <div className="scrollEffect_textBox d-flex align-items-center justify-content-between">
                      <div>
                        <span>18 August 1985</span>
                        <h3>Transition to Adulthood </h3>
                        <p>
                          Embarked on her academic odyssey, laying the
                          foundation for a remarkable journey..
                        </p>
                      </div>
                      <RippleEffect>
                        <Link
                          className="btn btn-danger"
                          onClick={() => setModalImage(true)}
                        >
                          See Details
                        </Link>
                      </RippleEffect>
                    </div>
                    <div className="scrollEffect_imgBox">
                      <ImageElement
                        id="img2"
                        source="theme02/capturedmoment-01.webp"
                        alt=" evolution-01 "
                      />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide className="scrollEffect_main w-100">
                    <div className="scrollEffect_textBox d-flex align-items-center justify-content-between">
                      <div>
                        <span>10 April 1985</span>
                        <h3>Establishing Independence</h3>
                        <p>
                          Continued her quest for knowledge, channeling her
                          passion into higher education...
                        </p>
                      </div>
                      <RippleEffect>
                        <Link
                          className="btn btn-danger"
                          onClick={() => setModalImage(true)}
                        >
                          See Details
                        </Link>
                      </RippleEffect>
                    </div>
                    <div className="scrollEffect_imgBox">
                      <ImageElement
                        id="img2"
                        source="theme02/capturedmoment-02.webp"
                        alt=" evolution-01 "
                      />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide className="scrollEffect_main w-100">
                    <div className="scrollEffect_textBox d-flex align-items-center justify-content-between">
                      <div>
                        <span>05 August 2002</span>
                        <h3>Building Relationships </h3>
                        <p>
                          adding a chapter of love and companionship to her
                          narrative...
                        </p>
                      </div>
                      <RippleEffect>
                        <Link
                          className="btn btn-danger"
                          onClick={() => setModalImage(true)}
                        >
                          See Details
                        </Link>
                      </RippleEffect>
                    </div>
                    <div className="scrollEffect_imgBox">
                      <ImageElement
                        id="img2"
                        source="theme02/capturedmoment-03.webp"
                        alt=" evolution-01 "
                      />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide className="scrollEffect_main w-100">
                    <div className="scrollEffect_textBox d-flex align-items-center justify-content-between">
                      <div>
                        <span>02 November 2015</span>
                        <h3>Commitment and Marriage</h3>
                        <p>Embraced a new chapter of love and commitment...</p>
                      </div>
                      <RippleEffect>
                        <Link
                          className="btn btn-danger"
                          onClick={() => setModalImage(true)}
                        >
                          See Details
                        </Link>
                      </RippleEffect>
                    </div>
                    <div className="scrollEffect_imgBox">
                      <ImageElement
                        id="img2"
                        source="theme02/capturedmoment-04.webp"
                        alt=" evolution-01 "
                      />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide className="scrollEffect_main w-100">
                    <div className="scrollEffect_textBox d-flex align-items-center justify-content-between">
                      <div>
                        <span>01 January 2024</span>
                        <h3>Family and Growth</h3>
                        <p>
                          welcomed a precious baby boy, illuminating her life
                          with the warmth of parenthood...
                        </p>
                      </div>
                      <RippleEffect>
                        <Link
                          className="btn btn-danger"
                          onClick={() => setModalImage(true)}
                        >
                          See Details
                        </Link>
                      </RippleEffect>
                    </div>
                    <div className="scrollEffect_imgBox">
                      <ImageElement
                        id="img2"
                        source="theme02/capturedmoment-05.webp"
                        alt=" evolution-01 "
                      />
                    </div>
                  </SwiperSlide>
                </Swiper>
              </div>
            </Row>
          </Container>
        </section>
      </main>
      {/* share modal */}
      <ModalComponent
        show={shareModal}
        size="md"
        title="Share Biography"
        closeButton="true"
        modalExtraClass="sharebiography"
        extraTitleClassName="sharebiography_title"
        onHandleCancel={handleCloseModal}
      >
        <div className="sharebiography_body">
          <form>
            <div className="d-flex align-items-end lh-1">
              <div className="form-group mb-0">
                <label className="form-label lh-sm">Copy Url</label>
                <input
                  id="url"
                  name="url"
                  className="form-control"
                  placeholder="Enter Url"
                  type="email"
                />
              </div>
              <RippleEffect>
                <Button variant="danger">Copy Link</Button>
              </RippleEffect>
            </div>
          </form>
        </div>
        <div className="sharebiography_footer">
          <h3>Share this link via</h3>
          <ul className="d-flex list-unstyled mb-0">
            <li>
              <Link
                to="#!"
                className="d-flex justify-content-center align-items-center"
              >
                <em className="icon-instagram" />
              </Link>
            </li>
            <li>
              <Link
                to="#!"
                className="d-flex justify-content-center align-items-center"
              >
                <em className="icon-twitter" />
              </Link>
            </li>
            <li>
              <Link
                to="#!"
                className="d-flex justify-content-center align-items-center"
              >
                <em className="icon-youtube" />
              </Link>
            </li>
            <li>
              <Link
                to="#!"
                className="d-flex justify-content-center align-items-center"
              >
                <em className="icon-facebook" />
              </Link>
            </li>
          </ul>
        </div>
      </ModalComponent>
      {/* Comment modal */}
      <ModalComponent
        show={commentModal}
        size="md"
        title="Write Comment"
        closeButton="true"
        modalExtraClass="commentModel"
        extraTitleClassName="commentModel_title"
        onHandleCancel={handleCloseModalComment}
      >
        <div className="commentModel_body">
          <form>
            <div className="d-sm-flex w-100">
              <div className="commentModel_left">
                <h2>Upload Picture/ pdf</h2>
                <div className="customUpload customUpload-icon customUpload-w100">
                  <Upload listType="picture-card" className="avatar-uploader">
                    <div>
                      <em className="icon-upload" />
                      <span className="d-block">Upload Picture/ Pdf</span>
                    </div>
                  </Upload>
                </div>
              </div>
              <div className="commentModel_right w-100">
                <h2>Comment</h2>
                <Row className="g-20">
                  <Col xs={12}>
                    <div className="form-group">
                      <textarea
                        className="form-control form-control-textarea w-100"
                        placeholder="Type Here"
                      />
                    </div>
                  </Col>
                </Row>
                <div className="commentModel_btn d-flex justify-content-end">
                  <RippleEffect>
                    <Button
                      className="btn btn-light rounded"
                      onClick={() => setCommentModal(false)}
                    >
                      Close
                    </Button>
                  </RippleEffect>
                  <RippleEffect>
                    <Button
                      className="btn btn-danger rounded"
                      onClick={() => setCommentModal(false)}
                    >
                      Send
                    </Button>
                  </RippleEffect>
                </div>
              </div>
            </div>
          </form>
        </div>
      </ModalComponent>
      {/* Image modal */}
      <ModalComponent
        size="md"
        show={showModalImage}
        onHandleCancel={handleCloseModalImage}
        extraClassName="imageSlider imageSlider-img"
        backdropClassName="sliderBack"
        closeVariant="white"
      >
        <Container>
          <div className="slider_content slider">
            <h2>Family and Growth</h2>
            <h3>January 2024</h3>
            <p className="mb-md-4 mb-3">
              Continued her quest for knowledge, channeling her passion into
              higher education...
            </p>
            <ImageElement
              className="img-fluid slider_img"
              source="theme01/slider-img-02.webp"
              alt="slider-img"
            />
          </div>
        </Container>
      </ModalComponent>
      {/* Image modal memory */}
      <ModalComponent
        // modalHeader="Image Slider"
        size="md"
        show={showModalImageMemory}
        onHandleCancel={handleCloseModalImageMemory}
        extraClassName="imageSlider"
        backdropClassName="sliderBack"
        pagination={{ clickable: true }}
        closeVariant="white"
      >
        <div className="slider">
          <h2 className="text-center">The Early Years</h2>
          <Swiper
            spaceBetween={20}
            slidesPerView={1.4}
            centeredSlides
            autoplay={{
              delay: 2500,
              pauseOnMouseEnter: true,
              disableOnInteraction: false,
            }}
            loop
            pagination={{
              clickable: true,
            }}
            navigation={{
              nextEl: ".next",
              prevEl: ".prev",
            }}
            breakpoints={{
              320: {
                slidesPerView: 1,
                spaceBetween: 10,
              },
              575: {
                slidesPerView: 1.3,
                spaceBetween: 10,
              },
              768: {
                slidesPerView: 1.4,
                spaceBetween: 15,
              },
              1024: {
                slidesPerView: 1.4,
                spaceBetween: 20,
              },
              1200: {
                slidesPerView: 1.8,
                spaceBetween: 20,
              },
            }}
            modules={[Autoplay, Pagination, Navigation]}
          >
            <SwiperSlide>
              <div className="slider_content">
                <h3>A Tale of Growing Up</h3>
                <p>
                  Within the tender embrace of the photograph, the pure essence
                  of innocence is beautifully captured, offering a heartfelt
                  glimpse into the precious world of babyhood.
                </p>
              </div>
              <ImageElement
                className="img-fluid slider_img"
                source="theme01/slider-img-01.webp"
                alt="slider-img"
              />
            </SwiperSlide>
            <SwiperSlide>
              <div className="slider_content">
                <h3>From Crayons to Graduation</h3>
                <p>
                  Within the tender embrace of the photograph, the pure essence
                  of innocence is beautifully captured, offering a heartfelt
                  glimpse into the precious world of babyhood.
                </p>
              </div>
              <ImageElement
                className="img-fluid slider_img"
                source="theme01/slider-img-02.webp"
                alt="slider-img"
              />
            </SwiperSlide>
            <SwiperSlide>
              <div className="slider_content">
                <h3>Navigating the Campus of Life</h3>
                <p>
                  Within the tender embrace of the photograph, the pure essence
                  of innocence is beautifully captured, offering a heartfelt
                  glimpse into the precious world of babyhood.
                </p>
              </div>
              <ImageElement
                className="img-fluid slider_img"
                source="theme01/slider-img-03.webp"
                alt="slider-img"
              />
            </SwiperSlide>
            <SwiperSlide>
              <div className="slider_content">
                <h3>Our Matrimonial Journey </h3>
                <p>
                  Within the tender embrace of the photograph, the pure essence
                  of innocence is beautifully captured, offering a heartfelt
                  glimpse into the precious world of babyhood.
                </p>
              </div>
              <ImageElement
                className="img-fluid slider_img"
                source="theme01/slider-img-01.webp"
                alt="slider-img"
              />
            </SwiperSlide>
            <SwiperSlide>
              <div className="slider_content">
                <h3>A Lifetime in Frames</h3>
                <p>
                  Within the tender embrace of the photograph, the pure essence
                  of innocence is beautifully captured, offering a heartfelt
                  glimpse into the precious world of babyhood.
                </p>
              </div>
              <ImageElement
                className="img-fluid slider_img"
                source="theme01/slider-img-02.webp"
                alt="slider-img"
              />
            </SwiperSlide>
            <SwiperSlide>
              <div className="slider_content">
                <h3>A Tale of Growing Up</h3>
                <p>
                  Within the tender embrace of the photograph, the pure essence
                  of innocence is beautifully captured, offering a heartfelt
                  glimpse into the precious world of babyhood.
                </p>
              </div>
              <ImageElement
                className="img-fluid slider_img"
                source="theme01/slider-img-03.webp"
                alt="slider-img"
              />
            </SwiperSlide>
            <SwiperSlide>
              <div className="slider_content">
                <h3>From Crayons to Graduation</h3>
                <p>
                  Within the tender embrace of the photograph, the pure essence
                  of innocence is beautifully captured, offering a heartfelt
                  glimpse into the precious world of babyhood.
                </p>
              </div>
              <ImageElement
                className="img-fluid slider_img"
                source="theme01/slider-img-01.webp"
                alt="slider-img"
              />
            </SwiperSlide>
            <SwiperSlide>
              <div className="slider_content">
                <h3>Navigating the Campus of Life</h3>
                <p>
                  Within the tender embrace of the photograph, the pure essence
                  of innocence is beautifully captured, offering a heartfelt
                  glimpse into the precious world of babyhood.
                </p>
              </div>
              <ImageElement
                className="img-fluid slider_img"
                source="theme01/slider-img-02.webp"
                alt="slider-img"
              />
            </SwiperSlide>
            <SwiperSlide>
              <div className="slider_content">
                <h3>Our Matrimonial Journey </h3>
                <p>
                  Within the tender embrace of the photograph, the pure essence
                  of innocence is beautifully captured, offering a heartfelt
                  glimpse into the precious world of babyhood.
                </p>
              </div>
              <ImageElement
                className="img-fluid slider_img"
                source="theme01/slider-img-03.webp"
                alt="slider-img"
              />
            </SwiperSlide>
            <SwiperSlide>
              <div className="slider_content">
                <h3>A Lifetime in Frames</h3>
                <p>
                  Within the tender embrace of the photograph, the pure essence
                  of innocence is beautifully captured, offering a heartfelt
                  glimpse into the precious world of babyhood.
                </p>
              </div>
              <ImageElement
                className="img-fluid slider_img"
                source="theme01/slider-img-01.webp"
                alt="slider-img"
              />
            </SwiperSlide>
          </Swiper>
          <div className="slider_btn">
            <Button type="button" className="prev">
              <em className="icon-left-arrow" />
            </Button>
            <Button type="button" className="next">
              <em className="icon-right-arrow" />
            </Button>
          </div>
        </div>
      </ModalComponent>
      {/* Report modal */}
      <ModalComponent
        show={showReportModal}
        size="md"
        title="Report Biography"
        closeButton="true"
        modalExtraClass="reportModal"
        extraTitleClassName="reportModal_title"
        onHandleCancel={handleCloseModalReport}
      >
        <form>
          <div className="reportModal_body">
            <h2>Are you sure to want to report this?</h2>
            <div className="form-group">
              <Select
                placeholder="Select Category"
                options={[
                  { value: "Category01", label: "Category01" },
                  { value: "Category02", label: "Category02" },
                  { value: "Category03", label: "Category03" },
                ]}
              />
            </div>
            <div className="form-group mb-0">
              <label className="form-label lh-sm">Reason for Report</label>
              <textarea
                className="form-control form-control-textarea"
                placeholder="Type Here"
              />
            </div>
          </div>
          <div className="reportModal_footer text-end">
            <RippleEffect>
              <Button
                className="btn btn-light rounded"
                onClick={() => setReportModal(false)}
              >
                Close
              </Button>
            </RippleEffect>
            <RippleEffect>
              <Button
                className="btn btn-danger rounded"
                onClick={() => setReportModal(false)}
              >
                Send Report
              </Button>
            </RippleEffect>
          </div>
        </form>
      </ModalComponent>
      {/* Memories video modal */}
      <ModalComponent
        show={showVideoModal}
        size="xl"
        title="Downloadable Memories"
        closeButton="true"
        modalExtraClass="videoModal"
        extraTitleClassName="videoModal_title"
        onHandleCancel={handleCloseModalVideo}
      >
        <form>
          <div className="videoModal_body">
            <div className="d-flex flex-wrap justify-content-between mb-sm-0 mb-3 w-100">
              <div className="commonSearch">
                <div className="form-group mb-0">
                  <div className="commonSearch_icn position-relative">
                    <input
                      id="serch"
                      name="serch"
                      className="form-control"
                      placeholder="Search Here"
                    />
                    <em className="icon-search position-absolute" />
                  </div>
                </div>
              </div>
              <div className="d-flex">
                <RippleEffect extraClassName="me-xl-2 me-1">
                  <Button
                    className="btn btn-light rounded"
                    onClick={handleSelectAllVideo}
                  >
                    {selectAllCheckedVideo ? "Unselect All" : "Select All"}
                  </Button>
                </RippleEffect>
                <RippleEffect extraClassName="ms-md-1 ms-0">
                  <Button className="btn btn-danger rounded">Download</Button>
                </RippleEffect>
              </div>
            </div>
            <Row>
              {videoMemories.map((el, index) => (
                <Col lg={4} sm={6} key={index}>
                  <Checkbox
                    checked={individualCheckboxesVideo[index]}
                    onChange={() => handleCheckboxChangeVideo(index)}
                  >
                    <div className="videoCard position-relative">
                      <ImageElement source={el.thumbnail} alt="video" />
                      <div className="videoCard_cnt d-flex justify-content-between align-items-center position-absolute w-100">
                        <h2 className="mb-0">{el.name}</h2>
                        <span className="d-inline-block">{el.duration}</span>
                      </div>
                      <Link
                        to="#!"
                        className="videoCard_playbtn position-absolute"
                        onClick={() => handleVideoFullShow(true)}
                      >
                        <div className="videoCard_playbtn_inner d-flex align-items-center justify-content-center">
                          <em className="icon-video" />
                        </div>
                      </Link>
                    </div>
                  </Checkbox>
                </Col>
              ))}
            </Row>
          </div>
        </form>
      </ModalComponent>
      {/* Memories audio modal */}
      <ModalComponent
        show={showAudioModal}
        size="xl"
        title="Downloadable Memories"
        closeButton="true"
        modalExtraClass="audioModal"
        extraTitleClassName="audioModal_title"
        onHandleCancel={handleCloseModalAudio}
      >
        <form>
          <div className="audioModal_body">
            <div className="d-flex flex-wrap justify-content-between mb-sm-0 mb-3 w-100">
              <div className="commonSearch">
                <div className="form-group mb-0">
                  <div className="commonSearch_icn position-relative">
                    <input
                      id="serch"
                      name="serch"
                      className="form-control"
                      placeholder="Search Here"
                    />
                    <em className="icon-search position-absolute" />
                  </div>
                </div>
              </div>
              <div className="d-flex">
                <RippleEffect extraClassName="me-xl-2 me-1">
                  <Button
                    className="btn btn-light rounded"
                    onClick={handleSelectAllAudio}
                  >
                    {selectAllCheckedAudio ? "Unselect All" : "Select All"}
                  </Button>
                </RippleEffect>
                <RippleEffect extraClassName="ms-md-1 ms-0">
                  <Button className="btn btn-danger rounded">Download</Button>
                </RippleEffect>
              </div>
            </div>
            <Row>
              {audioMemories.map((el, index) => (
                <Col lg={4} sm={6} key={index}>
                  <Checkbox
                    checked={individualCheckboxesAudio[index]}
                    onChange={() => handleCheckboxChangeAudio(index)}
                  >
                    <div className="audioCard position-relative">
                      <div className="d-flex align-items-center">
                        <Link
                          to="#!"
                          className="audioCard_icon d-flex justify-content-center align-items-center"
                        >
                          <em className="icon-video" />
                        </Link>
                        <div className="w-100">
                          <h3>{el.name}</h3>
                          <div className="audioCard_img d-flex align-items-center">
                            <ImageElement
                              source="audio.svg"
                              alt="audio"
                              className="w-100"
                            />
                            <span>{el.duration}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Checkbox>
                </Col>
              ))}
            </Row>
          </div>
        </form>
      </ModalComponent>
      {/* Memories video Full modal */}
      <ModalComponent
        show={showVideoFullModal}
        size="xl"
        title="Downloadable Memories"
        closeButton="true"
        modalExtraClass="videoModal"
        extraTitleClassName="videoModal_title"
        onHandleCancel={handleCloseModalVideoFull}
      >
        <form>
          <div className="videoModal_body">
            <Row>
              <Col sm={12}>
                <div className="videoCard-full position-relative overflow-hidden">
                  <ImageElement
                    source="modal-video-01.webp"
                    alt="video"
                    className="h-100 w-100 object-fit-cover"
                  />
                  <Link to="#!" className="videoCard_playbtn position-absolute">
                    <div className="videoCard_playbtn_inner d-flex align-items-center justify-content-center">
                      <em className="icon-video" />
                    </div>
                  </Link>
                </div>
              </Col>
            </Row>
          </div>
        </form>
      </ModalComponent>
      {/* Memories Pdf modal */}
      <ModalComponent
        show={showPdfModal}
        size="xl"
        title="Downloadable Memories"
        closeButton="true"
        modalExtraClass="videoModal"
        extraTitleClassName="videoModal_title"
        onHandleCancel={handleCloseModalPdf}
      >
        <form>
          <div className="videoModal_body">
            <div className="d-flex flex-wrap justify-content-between mb-sm-0 mb-3 w-100">
              <div className="commonSearch">
                <div className="form-group mb-0">
                  <div className="commonSearch_icn position-relative">
                    <input
                      id="serch"
                      name="serch"
                      className="form-control"
                      placeholder="Search Here"
                    />
                    <em className="icon-search position-absolute" />
                  </div>
                </div>
              </div>
              <div className="d-flex">
                <RippleEffect extraClassName="me-xl-2 me-1">
                  <Button
                    className="btn btn-light rounded"
                    onClick={handleSelectAll}
                  >
                    {selectAllChecked ? "Unselect All" : "Select All"}
                  </Button>
                </RippleEffect>
                <RippleEffect extraClassName="ms-md-1 ms-0">
                  <Button className="btn btn-danger rounded">Download</Button>
                </RippleEffect>
              </div>
            </div>
            <Row>
              {[0, 1, 2, 3, 4, 5].map((index) => (
                <Col lg={4} sm={6} key={index}>
                  <Checkbox
                    checked={individualCheckboxes[index]}
                    onChange={() => handleCheckboxChange(index)}
                  >
                    <div className="pdfCard position-relative d-flex align-items-center justify-content-center flex-column">
                      <ImageElement
                        source="theme03/pdf-white.webp"
                        alt="logo"
                      />
                      <Link className="viewBtn">View PDF</Link>
                    </div>
                  </Checkbox>
                </Col>
              ))}
            </Row>
          </div>
        </form>
      </ModalComponent>
    </>
  );
}

export default Theme02Static;
